import React, { useEffect, useState } from 'react';
import ContactForm from './ContactForm';
import { useTheme } from '../context/ThemeContext';

const ContactModal = ({ isOpen, onClose }) => {
  const { isDarkMode } = useTheme();
  const [isAnimating, setIsAnimating] = useState(false);

  // Close on escape key and handle animation
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
      // Trigger animation after mount
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
    }
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-start md:items-center justify-center overflow-y-auto"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div 
        className={`fixed inset-0 transition-opacity duration-300 ${isDarkMode ? 'bg-black/80' : 'bg-black/60'}`}
        style={{
          opacity: isAnimating ? 1 : 0,
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        }}
      />
      
      {/* Modal Container - scrollable on mobile */}
      <div className="relative z-10 w-full min-h-full md:min-h-0 flex items-start md:items-center justify-center py-4 md:py-8">
        {/* Modal Content */}
        <div 
          className="relative w-full max-w-lg mx-auto transition-all duration-300"
          onClick={(e) => e.stopPropagation()}
          style={{
            opacity: isAnimating ? 1 : 0,
            transform: isAnimating ? 'scale(1) translateY(0)' : 'scale(0.95) translateY(20px)',
          }}
        >
          {/* Close Button - always visible, fixed position on mobile */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className={`fixed md:absolute top-4 right-4 md:-top-3 md:-right-3 w-10 h-10 rounded-full ${
              isDarkMode ? 'bg-[#1A1A1A] hover:bg-[#2A2A2A] text-white' : 'bg-white hover:bg-gray-100 text-black'
            } shadow-lg flex items-center justify-center transition-all duration-300 z-50 hover:scale-110`}
            aria-label="Close modal"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
          
          <ContactForm onClose={onClose} />
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
